import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { selectMCBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';
import { selectMCByLocation } from 'shared/slice/masterControlSelectByLocationSlice';

import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  flexDirectionColumn,
  justifyContentSpaceBetween,
  layerA180Deg,
  layerC,
  layerA,
  readyTop180Deg,
  layerADisabled180Deg,
  layerBDisabled,
  cardPanel,
  cardInput,
} from 'shared/styles/commonStyles';

import SelectLocations from './SelectLocations';
import AtsSelectBox from './AtsSelectBox';
import InputTempMessage from 'shared/components/userMessages/inputTempMessage';
import {
  SwitchSectionTop,
} from 'features/masterControl/components/shared/styles/switchCardStyles';
import {
  SwitchButtonWrapper,
  SwitchButtonHole,
  SwitchButtonTop,
} from 'features/masterControl/components/shared/styles/controlButtons';

const Ats = ({
  scope,
  swtName,
  handleOnClick,
  handleClose,
  isMasterControl,
  specificLocation,
  disabled,
}) => {

  const isMobile = useMediaQuery({ query: '(max-width:600px)' });



  const type = scope === 'switch' ? 'locations' : 'switches';

  const switchStatus = useSelector(
    scope === 'switch' ? selectMCBySwitch : selectMCByLocation
  );
  const { selectedOne } = switchStatus.ats;


  const [isExpanded, setIsExpanded] = useState(false);
  const [isExpandedForMobile, setIsExpandedForMobile] = useState(false);
  const [isSelected, setIsSelected] = useState([false, false, false]);


  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);




  const imgSrc = 'images/logo-ats-active.svg';

  const selectOptions = {
    ess: [
      'BLOCK AND DO NOT ALLOW ESS TO OPERATE WHEN ON EBP (EMERGENCY BACKUP POWER)',
      ' REACTIVATES ESS WHEN POWERED BY EBP (EMERGENCY BACKUP POWER)',
    ],
    tgs: [
      'REACTIVATE TGS (TYPHOON GAS POWER HEATING SYSTEM) WHEN ON EBP (EMERGENCY BACKUP POWER)',
      'BLOCK AND DO NOT ALLOW TGS TO OPERATE WHEN ON EBP (EMERGENCY BACKUP POWER)',
    ],
    tes: [
      'SWITCH TO tgs (TYPHOON GAS POWERED HEATING SYSTEM) WHEN ON EBP (EMERGENCY BACKUP POWER)',
      'reactivate TES WHEN POWERED BY EBP (EMERGENCY BACKUP POWER)',
      'TES TO REMAIN OFF WHEN POWERED BY EBP (EMERGENCY BACKUP POWER)',
    ],
  };

  const handleApply = () => {
    if (!selectedOne) {

      setOpenMessageBox(true);
      setMessages(['select locations', 'please select location to continue']);

      handleOnClick('ats', 'selectA', scope, '_', '_', type, specificLocation);
    } else if (!isSelected.includes(true)) {
      handleOnClick(
        'ats',
        'selectC',
        scope,
        null,
        null,
        null,
        specificLocation
      );

      setOpenMessageBox(true);
      setMessages(['select ats', 'please select an ats option to continue']);
    } else {

      handleOnClick('ats', 'on', scope, null, isSelected);
      setIsSelected([false, false, false]);
    }
  };

  const handleOpenAts = () => {
    setIsExpanded(!isExpanded);
  };

  const handleAtsSelect = (id) => {
    if (id === 0) {
      setIsSelected([true, false, false]);
    } else if (id === 1) {
      setIsSelected([false, true, false]);
    } else if (id === 2) {
      setIsSelected([false, false, true]);
    }
  };

  const handleAtsButtons = (id) => {
    if (id === 0) {

      setIsSelected([false, false, false]);
    } else if (id === 1) {
      setIsExpanded(false);
      if (isMobile && scope !== 'switch') {
        handleApply();
        handleClose();
      } else if (isMasterControl) {
        handleOnClick(isSelected);
      }
    }
  };

  return (
    <>
      {isMobile ? (
        <>
          {isMasterControl ? (
            <AtsSelectBox
              isMasterControl={isMasterControl}
              isMobile={true}
              handleButtons={handleAtsButtons}
              handleSelect={handleAtsSelect}
              isSelected={isSelected}
              handleOpenAts={handleOpenAts}
              swtName={swtName}
              options={
                swtName === 'ess'
                  ? selectOptions.ess
                  : swtName === 'tes'
                  ? selectOptions.tes
                  : selectOptions.tgs
              }
            />
          ) : (
            <>
              {scope === 'switch' ? (
                <MobileWrapper isExpanded={isExpandedForMobile}>
                  <SectionController
                    isMobile={isMobile}
                    isMargin={isMobile && isExpandedForMobile}
                  >
                    <MobileHole>
                      <MobileTop disabled={disabled}>
                        <SectionCircle disabled={disabled}>
                          <CircleButton
                            onClick={handleApply}
                            disabled={disabled}
                          >
                            <CircleHole disabled={disabled}>
                              <LogoImg src={imgSrc} />
                            </CircleHole>
                          </CircleButton>
                        </SectionCircle>

                        <SectionHeatButton disabled={disabled}>
                          <HeatButton onClick={handleApply} disabled={disabled}>
                            select<br></br>ats
                          </HeatButton>
                        </SectionHeatButton>

                        <SectionCircle disabled={disabled}>
                          <CircleButton
                            isExpanded={isExpandedForMobile}
                            disabled={disabled}
                            onClick={() => {
                              setIsExpandedForMobile(!isExpandedForMobile);
                            }}
                          >
                            <CircleHole disabled={disabled}>
                              <CircleTop
                                isExpanded={isExpandedForMobile}
                                disabled={disabled}
                              >
                                <LogoImg
                                  isSm={true}
                                  src={
                                    disabled
                                      ? '/images/MC-expand-disabled.svg'
                                      : isExpanded
                                      ? '/images/MC-expand-true.svg'
                                      : '/images/MC-expand-false.svg'
                                  }
                                />
                              </CircleTop>
                            </CircleHole>
                          </CircleButton>
                        </SectionCircle>
                      </MobileTop>
                    </MobileHole>
                  </SectionController>

                  {isExpandedForMobile && (
                    <SectionSelects swtName={swtName}>
                      <SelectLocations
                        name='ats'
                        scope={scope}
                        swtName={swtName}
                        specificLocation={specificLocation}
                      />
                      <AtsSelectBox
                        isMobile={true}
                        handleButtons={handleAtsButtons}
                        handleSelect={handleAtsSelect}
                        isSelected={isSelected}
                        handleOpenAts={handleOpenAts}
                        swtName={swtName}
                        options={
                          swtName === 'ess'
                            ? selectOptions.ess
                            : swtName === 'tes'
                            ? selectOptions.tes
                            : selectOptions.tgs
                        }
                      />
                    </SectionSelects>
                  )}
                  {openMessageBox && (
                    <MobileMessageBoxWrapper>
                      <InputTempMessage
                        onClose={() => setOpenMessageBox(false)}
                        title={'master control'}
                        subtitle={'select ats'}
                        messages={messages}
                        isMobile={isMobile}
                      />
                    </MobileMessageBoxWrapper>
                  )}
                </MobileWrapper>
              ) : (
                <MobileWrapper isSmall={scope !== 'switch'}>
                  <SelectLocations
                    name='ats'
                    scope={scope}
                    swtName={swtName}
                    specificLocation={specificLocation}
                  />
                  <SelectWrapper swtName={swtName}>
                    <AtsSelectBox
                      isMobile={true}
                      isSmall={true}
                      handleButtons={handleAtsButtons}
                      handleSelect={handleAtsSelect}
                      isSelected={isSelected}
                      handleOpenAts={handleOpenAts}
                      swtName={swtName}
                      options={
                        swtName === 'ess'
                          ? selectOptions.ess
                          : swtName === 'tes'
                          ? selectOptions.tes
                          : selectOptions.tgs
                      }
                    />
                  </SelectWrapper>
                  {openMessageBox && (
                    <MobileMessageBoxWrapper>
                      <InputTempMessage
                        onClose={() => setOpenMessageBox(false)}
                        title={'master control'}
                        subtitle={'select ats'}
                        messages={messages}
                        isMobile={isMobile}
                      />
                    </MobileMessageBoxWrapper>
                  )}
                </MobileWrapper>
              )}
            </>
          )}
        </>
      ) : (
        <Wrapper disabled={disabled}>
          <SwitchSectionTop disabled={disabled}>
            <Title disabled={disabled}>
              ATS
              <img src={imgSrc} alt='ats' />
            </Title>
            <SelectLocations
              size={2}
              disabled={disabled}
              name='ats'
              scope={scope}
              swtName={swtName}
              specificLocation={specificLocation}
            />
          </SwitchSectionTop>

          <SectionBottom>
            {isExpanded ? (
              <AtsSelectBox
                handleButtons={handleAtsButtons}
                handleSelect={handleAtsSelect}
                isSelected={isSelected}
                handleOpenAts={handleOpenAts}
                swtName={swtName}
                options={
                  swtName === 'ess'
                    ? selectOptions.ess
                    : swtName === 'tes'
                    ? selectOptions.tes
                    : selectOptions.tgs
                }
              />
            ) : (
              <AtsControlRow>
                <AtsSelectPill
                  type='button'
                  disabled={disabled}
                  onClick={() => disabled || handleOpenAts()}
                >
                  <AtsSelectText disabled={disabled}>
                    {isSelected.includes(true) ? 'selected' : 'select ats'}
                  </AtsSelectText>
                  <ArrowImg
                    src='/images/masterCtr-select-btn.svg'
                    disabled={disabled}
                  />
                </AtsSelectPill>

                <SwitchButtonWrapper
                  $w='64px'
                  onClick={handleApply}
                  disabled={disabled}
                >
                  <SwitchButtonHole disabled={disabled}>
                    <SwitchButtonTop disabled={disabled}>apply</SwitchButtonTop>
                  </SwitchButtonHole>
                </SwitchButtonWrapper>
              </AtsControlRow>
            )}
            {openMessageBox && (
              <MessageBoxWrapper>
                <InputTempMessage
                  onClose={() => setOpenMessageBox(false)}
                  title={'master control'}
                  subtitle={'select ats'}
                  messages={messages}
                  isMobile={isMobile}
                />
              </MessageBoxWrapper>
            )}
          </SectionBottom>
        </Wrapper>
      )}
    </>
  );
};

export default Ats;

const MobileWrapper = styled.div`
  position: relative;
  ${(p) =>
    p.isSmall
      ? css`
          ${flexDirectionColumn};
          padding-top: 6px;
        `
      : css`
          width: 314px;
          height: 72px;
          border-radius: 36px;
          ${layerC};
          ${flexBoxCenter};

          ${(p) =>
            p.isExpanded &&
            css`
              height: auto;
              border-radius: 36px;
              ${flexDirectionColumn};
              padding: 2px 0;
              border-radius: 36px 36px 26px 26px;
            `}

          margin-bottom:8px;
        `};
`;

const SelectWrapper = styled.div`
  width: 305px;
  height: ${(p) => (p.swtName === 'tes' ? `246px` : `206px`)};
  background: #233a54;
  border-radius: 11px 11px 26px 26px;
  ${flexBoxCenter};
  margin-top: 8px;
`;

const SectionController = styled.section`
  width: 310px;
  height: 68px;
  border-radius: 34px;
  ${layerA180Deg};
  ${flexBoxCenter}
`;

const MessageBoxWrapper = styled.div`
  width: 1180px;
  height: 300px;
  position: absolute;

  ${flexBoxCenter}

  top: 40%;
  left: 0;
  z-index: 100;
`;

const MobileHole = styled.div`
  width: 299px;
  height: 58px;
  border-radius: 29px;
  ${layerA};
  ${flexBoxCenter};
`;

const MobileTop = styled.div`
  width: 293px;
  height: 52px;
  border-radius: 26px;
  padding: 0 2px;
  ${layerA180Deg};
  ${justifyContentSpaceBetween};

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg};
    `}
`;

const SectionCircle = styled.section`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  ${layerC}
  ${flexBoxCenter}

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}
`;
const CircleButton = styled.button`
  width: 46px;
  height: 46px;
  border-radius: 50%;
  ${layerA180Deg};
  ${flexBoxCenter};

  ${(p) =>
    p.isExpanded &&
    css`
      ${readyTop180Deg}
    `}

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
      cursor: not-allowed;
    `}
`;
const CircleHole = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 50%;
  ${layerA};
  ${flexBoxCenter};

  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}
`;
const CircleTop = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  ${layerA180Deg};
  ${flexBoxCenter};

  ${(p) =>
    p.isExpanded &&
    css`
      ${readyTop180Deg}
    `}

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
    `}
`;

const LogoImg = styled.img`
  width: 65%;

  ${(p) =>
    p.isSm &&
    css`
      height: auto;
      width: auto;
    `}
`;

const SectionHeatButton = styled.section`
  width: 188px;
  height: 36px;
  border-radius: 18px;

  ${layerA}
  ${flexBoxCenter}


  ${(p) =>
    p.disabled &&
    css`
      ${layerBDisabled}
    `}
`;
const HeatButton = styled.button`
  width: 186px;
  height: 34px;

  border-radius: 17px;

  ${layerA180Deg}
  ${flexBoxCenter}
  font-size: 10px;
  line-height: 95%;
  padding-top: 2px;

  ${(p) =>
    p.disabled &&
    css`
      ${layerADisabled180Deg}
      cursor: not-allowed;
    `}
`;

const SectionSelects = styled.section`
  margin-top: 6px;
  ${flexDirectionColumn}
`;


const Wrapper = styled.div`
  ${cardPanel}
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16.8px;
  width: 100%;
  height: 169.6px;
  position: relative;
  overflow: visible;

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;
    `}
`;

const Title = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--switch-text-secondary);
  text-transform: uppercase;
  position: relative;
  z-index: 1;

  img {
    width: 16px;
    height: 16px;
    filter: drop-shadow(0px 0px 16px rgba(52, 211, 153, 0.6));
  }
`;

const SectionBottom = styled.section`
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 1;
`;

const AtsControlRow = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
`;

const AtsSelectPill = styled.button`
  flex: 1;
  min-width: 0;
  height: 40px;
  ${cardInput}
  border-radius: 9999px;
  box-shadow: inset 0px 2px 8px rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px 0 16.8px;
  cursor: pointer;

  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
    `}
`;

const AtsSelectText = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: var(--switch-text-secondary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${(p) =>
    p.disabled &&
    css`
      color: var(--switch-text-faint);
    `}
`;

const ArrowImg = styled.img`
  width: 12px;
  height: 10px;
  flex-shrink: 0;
  cursor: pointer;

  ${(p) =>
    p.disabled &&
    css`
      cursor: not-allowed;
    `}
`;

const MobileMessageBoxWrapper = styled.div`
  width: auto;
  height: auto;

  ${flexBoxCenter}

  position: absolute;
  top: 50px;
  left: -32px;

  z-index: 100;
`;
